import { Routes, Themes } from '@/utils/constants';
import { clearStorage, getAuthUserType } from '@/utils/helpers/auth';
import { UserType } from '@/utils/types';
import { useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

export const useUserType = () => {
  const navigate = useNavigate();
  const userType = getAuthUserType();

  const theme = useMemo(() => {
    return {
      ...(userType === 'parent'
        ? Themes.parent
        : userType === 'organization'
          ? Themes.org
          : Themes.child),
      all: { ...Themes },
    };
  }, [userType]);

  useEffect(() => {
    if (!userType) {
      clearStorage();
      navigate(Routes.login);
    }
  }, [navigate, userType]);

  return {
    userType: userType as UserType,
    theme,
  };
};
